import {
    getReportRun,
    listReportRuns
} from './queries';
import {
    createReportRun,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {ReportRun} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListReportRuns = {
    listReportRuns: { items: ReportRun[], nextToken?: string }
}

export type GetReportRun = {
    getReportRun: ReportRun
}

export type CreateReportRun = {
    createReportRun: ReportRun
}

const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListReportRuns>>({
                                                                            query: listReportRuns,
                                                                            variables: {filter: filter, limit, nextToken},
                                                                        });
    return response.data?.listReportRuns;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetReportRun>>({
                                                                          query: getReportRun,
                                                                          variables: {id: id},
                                                                      });
    return response.data?.getReportRun;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateReportRun>>({
                                                                             query: createReportRun,
                                                                             variables: {input: payload},
                                                                         });
    return response.data?.createReportRun;
};
